import { Toaster } from "sonner";
import { useLocation } from "react-router";
import Sidebar from "./sidebar";
import { AppRoutes } from "@/routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect } from "react";
import ProfileRepository from "@/repositories/profile.repo";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setUser } from "@/store/slicers/auth.slicer";
import BusinessSuspended from "@/components/business-suspended";
import ModuleRouteGuard from "@/components/module-route-guard";
import Navbar from "./navbar";

const queryClient = new QueryClient();

// While suspended, only these areas stay reachable so the owner can see status / manage billing.
const SUSPENDED_ALLOWED_PATHS = ["/dashboard/subscription", "/dashboard/business"];

const MainLayout = () => {
  const repository = new ProfileRepository();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const user = useAppSelector((state) => state.auth.user);

  useEffect(() => {
    (async () => {
      const data = await repository.get();
      dispatch(setUser(data));
    })();
  }, []);

  const status = user?.business?.status;
  const suspended = !user?.is_default && !!status && status !== "active";
  const onAllowedPath = SUSPENDED_ALLOWED_PATHS.some((p) => location.pathname.startsWith(p));
  const blockContent = suspended && !onAllowedPath;

  return (
    <main className="bg-teal-900/10 h-full w-full overflow-hidden flex flex-row">
      <QueryClientProvider client={queryClient}>
        <ModuleRouteGuard />
        <Sidebar />
        <div className="w-full h-full flex flex-col">
          <Navbar />
          {blockContent ? <BusinessSuspended status={status} /> : <AppRoutes />}
        </div>
        <Toaster />
      </QueryClientProvider>
    </main>
  );
};

export default MainLayout;
